export default {"src":"/_next/static/media/magnifying-glass.d6307a38.svg","height":89,"width":88,"blurWidth":0,"blurHeight":0};